import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

type PaidUserReturnValueType = 'a' | 'b' | 'c' | 'd' | false;
type PaidUserReturnTariffs = Record<
    string,
    {
        discount: number;
        year: string;
        month: string;
    }
>;
interface PaidUserReturnPromoSettings {
    period: string;
}

const paidUserReturnValue: PaidUserReturnValueType = !IS_MOBILE_BROWSER && !IS_WEBVIEW && getFeature('paid-user-return-ab');

const paidUserReturnDiscounts: PaidUserReturnTariffs = getFeature('paid-user-return-tariffs') || {
    b: { discount: 10, month: 'W512GB_1m_returning_paid_users_2025_10', year: 'W512GB_1y_returning_paid_users_2025_10' },
    c: { discount: 20, month: 'W512GB_1m_returning_paid_users_2025_20', year: 'W512GB_1y_returning_paid_users_2025_20' },
    d: { discount: 30, month: 'W512GB_1m_returning_paid_users_2025_30', year: 'W512GB_1y_returning_paid_users_2025_30' },
};

export const paidUserReturnPromoSettings: PaidUserReturnPromoSettings = getFeature('paid-users-return-promo-settings') || { period: '1m' };

const expDisabled = !paidUserReturnValue || paidUserReturnValue === 'a';

export const paidUserReturnAB = {
    enabled: !expDisabled,
    tariff: !expDisabled ? paidUserReturnDiscounts[paidUserReturnValue] : undefined,
};

registerExperiment(
    'paid-user-return',
    paidUserReturnValue,
    [
        AnalyticEventNames.PAID_USER_RETURN_MODAL_SHOW,
        AnalyticEventNames.PAID_USER_RETURN_MODAL_CLICK,
        AnalyticEventNames.PAID_USER_RETURN_MODAL_CLOSE,
    ],
    {
        mapEventNames: {
            PAID_USER_RETURN_MODAL_SHOW: 'modal-show',
            PAID_USER_RETURN_MODAL_CLICK: 'modal-click',
            PAID_USER_RETURN_MODAL_CLOSE: 'modal-close',
        },
    }
);
